<template>
  <div v-loading="pageLoading" class="home-wrap">
    <action-bar>
      <search placeholder="输入区块Hash/区块高度/交易ID/合约名称搜索" @onSearch="onSearch"></search>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <subscribe-block></subscribe-block>
    </action-bar>
    <el-row class="plate-box">
      <el-col :span="16">
        <plate title="交易统计" class="transaction-statistics" sub-tit="(近24小时)">
          <template slot="content">
            <txn-line></txn-line>
          </template>
        </plate>
        <plate title="区块链概览" class="chain-profile">
          <template slot="content">
            <summary-data></summary-data>
          </template>
        </plate>
        <plate title="最新交易" class="latest-transaction" :show-more="showMore" :event="events">
          <template slot="content">
            <latest-txn></latest-txn>
          </template>
        </plate>
      </el-col>
      <el-col :span="8">
        <plate title="最新区块" class="latest-block" :show-more="showMore" :event="events">
          <template slot="content">
            <latest-block></latest-block>
          </template>
        </plate>
        <plate title="最新合约" class="latest-contract" :show-more="showMore" :event="events">
          <template slot="content">
            <latest-contract></latest-contract>
          </template>
        </plate>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import summaryData from './components/summaryData'
import txnLine from './components/txnChart'
import latestBlock from './components/latestBlock'
import latestTxn from './components/latestTxn'
import latestContract from './components/latestContract'
import subscribeBlock from './components/subscribeBlock'
export default {
  name: 'Home',
  components: {
    summaryData,
    txnLine,
    latestBlock,
    latestTxn,
    latestContract,
    subscribeBlock
  },
  data() {
    return {
      showMore: true,
      events: {
        click: row => {
          return this.getLink(row)
        }
      }
    }
  },
  computed: {
    pageLoading: {
      get() {
        return this.$store.state.home.homeLoading
      }
    }
  },
  mounted() {
    this.$store.commit('updateLoading', true)
  },
  methods: {
    getLink(row) {
      let name =
        row === '最新区块' ? 'blockInfo' : row === '最新合约' ? 'contractInfo' : 'transactionInfo'
      this.$router.push({
        name
      })
    },
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    },
    onSearch(inputValue) {
      let param = {
        chainId: this.$store.state.home.chainCid,
        content: inputValue
      }
      this.$apis.home.getSearch(param).then(res => {
        if (res.data && res.data.Type !== -1) {
          let type = res.data.Type
          let router = ['blockDetail', 'txnDetail', 'contractDetail']
          let queryData = ['blockHeight', 'txId', 'contractName']
          this.$router.push({
            name: router[type],
            query: {
              chainId: res.data.ChainId,
              [queryData[type]]: res.data.Data
            }
          })
        } else {
          this.$message.error('没有找到对应的区块、交易或合约信息')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-wrap',
  (
    //home
      --theme-text-color: #072d4d,
    --table-head-color: #2f5575,
    --table-head-text: #072d4d,
    --back-arrow-color: #758a9b,
    //home profile
      --home-profile-num-color: #fff,
    --home-profile-name-color: #a3afb5,
    //home transcation
      --home-trans-cell-bottom-color: #33496e,
    --home-trans-header-text-color: #8babba,
    --home-trans-body-text-color: #fff,
    --home-trans-body-sender-text-color: #1cbcff,
    --home-trans-body-create-time-text-color: #a3afb5,
    --home-trans-row-hover-background-color: #3e4e77,
    //home contract
      --home-contract-item-hover-background-color: #030b1c,
    --home-contract-item-opacity: 0.2,
    --home-contract-item-border-color: #45c2ff,
    --home-contract-item-name-color: #45c2ff,
    --home-contract-item-version-background-color: #26426a,
    --home-contract-item-version-color: #b2d9eb,
    --home-contract-item-bottom-color: #a3afb5,
    --home-contract-item-time-color: #517080,
    //home block
      --home-block-item-icon-url: url('~@/assets/images/home/dark/chain-height-bg.png'),
    --home-block-item-hover-background-color: #031234,
    --home-block-item-background-color: #07183f,
    --home-block-item-left-section-color: #fff,
    --home-block-item-right-section-color: #fff,
    --home-block-item-right-second-line-color: #a3afb5,
    --home-block-item-right-time-color: #517080
  ),
  (
    //home
      --theme-text-color: #2a8dcb,
    --table-head-color: #2a8dcb,
    --table-head-text: #303333,
    --back-arrow-color: #2a8dcb,
    //home profile
      --home-profile-num-color: #122836,
    --home-profile-name-color: #88939a,
    //home transcation
      --home-trans-cell-bottom-color: #ebebeb,
    --home-trans-header-text-color: #88939a,
    --home-trans-body-text-color: #122836,
    --home-trans-body-sender-text-color: #1cbcff,
    --home-trans-body-create-time-text-color: #5a6973,
    --home-trans-row-hover-background-color: #f9f9fa,
    //home contract
      --home-contract-item-hover-background-color: #f9f9fa,
    --home-contract-item-opacity: 1,
    --home-contract-item-border-color: #f4f2f9,
    --home-contract-item-name-color: #45c2ff,
    --home-contract-item-version-background-color: #daf3ff,
    --home-contract-item-version-color: #92c8e2,
    --home-contract-item-bottom-color: #5a6973,
    --home-contract-item-time-color: #88939a,
    //home block
      --home-block-item-icon-url: url('~@/assets/images/home/chain-height-bg.png'),
    --home-block-item-hover-background-color: #ebebeb,
    --home-block-item-background-color: #f9f9f9,
    --home-block-item-left-section-color: #fff,
    --home-block-item-right-section-color: #122836,
    --home-block-item-right-second-line-color: #5a6973,
    --home-block-item-right-time-color: #88939a
  )
);

.home-wrap {
  @include adaptation(
    (
      //卡片相关
        --home-plate-box-margin: 0 -8px,
      --home-plate-box-padding: 0 8px,
      --home-plate-box-height: 684px,
      --home-plate-box-vertical-gap: 16px,
      --home-plate-box-transaction-statistics-height: 236px,
      --home-plate-box-chain-profile-height: 136px,
      --home-plate-box-latest-transaction-height: 280px,
      --home-plate-box-latest-block-height: 388px,
      --home-plate-box-latest-contract-height: 280px,
      //简介
        --home-profile-item-height: 47px,
      --home-profile-item-padding: 0 10px,
      --home-profile-icon-size: 40px,
      --home-profile-icon-margin-right: 12px,
      --home-profile-num-margin-top: 4px,
      --home-profile-num-font-size: 26px,
      --home-profile-num-height: 26px,
      --home-profile-name-font-size: 12px,
      --home-profile-name-height: 17px,
      //最新交易
        --home-trans-padding: 4px 16px 2px 16px,
      --home-trans-fontsize: 12px,
      --home-trans-row-height: 41px,
      --home-trans-cell-height: 24px,
      --home-trans-cell-padding: 6px 0 6px,
      --home-trans-cell-content-padding: 0 10px 0 0,
      --home-trans-cell-border-bottom-width: 1px,
      //最新合约
        --home-contract-padding-top: 32px,
      --home-contract-padding-left: 16px,
      --home-contract-padding-right: 16px,
      --home-contract-item-height: 72px,
      --home-contract-item-margin-bottom: 25px,
      --home-contract-item-fontsize: 12px,
      --home-contract-item-padding: 12px 16px,
      --home-contract-item-bg-border-radius: 4px,
      --home-contract-item-bg-border-width: 1px,
      --home-contract-item-name-height: 20px,
      --home-contract-item-name-fontsize: 14px,
      --home-contract-item-name-margin-right: 8px,
      --home-contract-item-version-height: 16px,
      --home-contract-item-version-fontsize: 10px,
      --home-contract-item-version-border-radius: 2px,
      --home-contract-item-version-padding: 1px 6px,
      --home-contract-item-bottom-height: 17px,
      --home-contract-item-bottom-fontsize: 12px,
      --home-contract-item-bottom-margin-top: 12px,
      --home-contract-item-seperator-margin: 0 4px,
      //最新区块
        --home-block-padding: 32px 16px 26px 16px,
      --home-block-item-height: 90px,
      --home-block-item-border-radius: 4px,
      --home-block-item-margin-bottom: 16px,
      --home-block-item-padding: 20px 16px,
      --home-block-item-icon-height: 50px,
      --home-block-item-icon-padding: 12px 13px,
      --home-block-item-icon-margin-right: 12px,
      --home-block-item-info-height: 26px,
      --home-block-item-info-min-width: 24px,
      --home-block-item-info-fontsize: 26px,
      --home-block-item-des-height: 50px,
      --home-block-item-des-fontsize: 14px,
      --home-block-item-des-firstline-height: 20px,
      --home-block-item-des-firstline-margin-bottom: 12px,
      --home-block-item-des-secondline-height: 17px,
      --home-block-item-des-secondline-fontsize: 12px,
      --home-block-item-des-secondline-seperator-margin: 0 4px
    )
  );

  .plate-box {
    margin: var(--home-plate-box-margin);
    height: var(--home-plate-box-height);

    .el-col {
      padding: var(--home-plate-box-padding);

      .cbaas-plate.transaction-statistics {
        height: var(--home-plate-box-transaction-statistics-height);
        margin-bottom: var(--home-plate-box-vertical-gap);
      }

      .cbaas-plate.chain-profile {
        height: var(--home-plate-box-chain-profile-height);
        margin-bottom: var(--home-plate-box-vertical-gap);
      }

      .cbaas-plate.latest-transaction {
        height: var(--home-plate-box-latest-transaction-height);
      }

      .cbaas-plate.latest-block {
        height: var(--home-plate-box-latest-block-height);
        margin-bottom: var(--home-plate-box-vertical-gap);
      }

      .cbaas-plate.latest-contract {
        height: var(--home-plate-box-latest-contract-height);
      }
    }
  }
}
</style>
